module.exports = __webpack_public_path__ + "static/media/olivefooter.f6fc4aa8.png";